module.exports = __webpack_public_path__ + "img/arrow-right-circle.7e1fb898.svg";